
<style scoped lang="scss">
.voucher-intro-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.65);
    z-index: 10000;
}
.voucher-intro-container {
    position: fixed;
    left: 0px;
    bottom: 0;
    width: 100%;
    background: $white;
    z-index: 10001;
    display: flex;
    flex-direction: column;
    height: $modal-height;
    white-space: pre-line;
    word-break: break-word;
    overflow: auto;
    -webkit-overflow-scrolling: touch;  
    .t-top {
        height: 1.146667rem;
        line-height: 1.146667rem;
        color: #666666;
        font-size: 16px;
        text-align: center;
        position: relative;
        border-bottom: 1px solid #ebebeb;
        flex: none;
        .close {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 0;
            top: 0;
            width: 1.44rem;
            height: 100%;
            img {
                width: 0.426667rem;
                height: 0.426667rem;
            }
        }
    }
    .t-center {
        // height: 10.586667rem;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        flex: 1 1 auto;
        height: 100%;
        padding-bottom: 1.333333rem;
        .each-intro {
            padding-top: 0.533333rem;
            .intro-title {
                position: relative;
                padding-left: 0.3rem;
                font-size: 14px;
                color: #333;
                font-weight: bold;
                margin-bottom: 0.4rem;
                &:before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 0.106667rem;
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    background: $blue;
                }
            }
            .intro-row {
                margin-bottom: 0.4rem;
                font-size: 14px;
                padding: 0 0.373333rem;
                display: flex;
                .key {
                    color: #333;
                    min-width: 1.866667rem;
                }
                .value {
                    color: #808080;
                    padding-left: 0.14rem;
                    &.value-wra {
                        display: flex;
                        flex-direction: column;
                        span {
                            line-height: 1.6;
                        }
                    }
                }
            }
        }
    }
    .t-bottom {
        height: 1.333333rem;
        padding-left: 0.44rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: -1px -1px 10px rgba(0, 0, 0, 0.09);
        flex: none;
        .price {
            color: $orange;
            font-size: 21px;
            font-weight: bold;
        }
        .yd-btn {
            background: $blue;
            height: 1.333333rem;
            line-height: 1.333333rem;
            width: 3.2rem;
            text-align: center;
            color: $white;
            font-size: 17px;
        }
    }
}
</style>

<template>

    <div>
        <transition name="fade">
            <div class="voucher-intro-wrapper"
                v-show="isOpen"
                @click.stop="closeModal">

            </div>
        </transition>
        <transition name="slideup">
            <div class="voucher-intro-container"
                v-show="isOpen">
                <div class="t-top">
                    <span>使用说明</span>
                    <div class="close"
                        @click.stop="closeModal">
                        <img src="https://oss.tuoxingwang.com/vaporetto-assets/scene/png/close-icon.png"
                            alt="close-icon">
                    </div>

                </div>

                <div class="t-center" id="modal_scroll_container">
                    <div class="each-intro">
                        <div class="intro-row">
                            <span class="key">有效期：</span>
                            <span class="value"
                                v-text="avaliableText"></span>
                        </div>

                    </div>
                    <div class="each-intro"
                        v-if="introData.availableScope">
                        <div class="intro-title">适用范围</div>
                        <div class="intro-row"><span class="key"
                                v-text="introData.availableScope"></span>
                        </div>
                    </div>
                    <div class="each-intro"
                        v-if="introData.usageRule">
                        <div class="intro-title">使用规则</div>
                        <div class="intro-row"><span class="key"
                                v-text="introData.usageRule"></span>
                        </div>
                    </div>

                </div>
                <div class="t-bottom"
                    v-if="isShowBottom">
                    <div class="price">￥{{introData.salePrice}}</div>
                    <div class="yd-btn"
                        @click="toBuy">预定</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import MODAL_MIXINS from "@/components/common/ModalCommonMixins";
export default {
    name: "VoucherIntroModal",
    components: {},
    mixins: [MODAL_MIXINS],
    props: {
        introData: Object,
        isShowBottom: Boolean,
        title: String
    },
    data() {
        return {};
    },
    computed: {
        avaliableText() {
            let {
                availablePeriodType,
                availablePeriodStart,
                availablePeriodEnd,
                availablePeriodDays
            } = this.introData;
            if (availablePeriodType == 1) {
                return `自购买日期起${availablePeriodDays}天内有效`;
            } else if (availablePeriodType == 2) {
                return `${availablePeriodStart} ~ ${availablePeriodEnd}`;
            } else if (availablePeriodType == 3) {
                return `永久有效`;
            }
        }
    },
    watch: {},
    created() {},
    mounted() {
        // axios
        // 	.post("http://boms_api.dugujiujian.net/admin/login", {
        // 		password: "12345*6",
        // 		userName: "admini"
        // 	})
        // 	.then(res => {
        // 		console.log(res.data);
        // 	});
    },
    destroyed() {},
    methods: {
        toBuy() {
            this.$router.push({
                name: "foodOrder",
                params: {
                    foodId: this.introData.id
                }
            });
        }
    }
};
</script>

